import React from 'react';

export default class DeleteIcon extends React.Component {
  render() {
    return <div className="delete-icon" onClick={this.props.onChange} />;
  }
}
